'use client'

import React from 'react'
import { LayoutGrid, List } from 'lucide-react'
import { useDispatch } from 'react-redux'
import { useAppSelector, useIsMobile } from '@/lib/hooks'
import { setProductViewMode } from '@/lib/redux'
import { cn } from '@/lib/utils'

import { Button } from '@/components/ui'

interface HeadingBarProps extends React.ComponentPropsWithoutRef<'div'> {}

export const HeadingBar = ({ className, ...restProps }: HeadingBarProps) => {
  const isMobile = useIsMobile()
  const dispatch = useDispatch()
  const { productViewMode } = useAppSelector((state) => state.appSession)

  const handleToggle = (mode: 'vertical' | 'horizontal') => {
    dispatch(setProductViewMode(mode))
    localStorage?.setItem('productViewMode', mode)
  }

  React.useEffect(() => {
    if (isMobile) {
      dispatch(setProductViewMode('horizontal'))
    }
  }, [isMobile, dispatch])

  return (
    <div
      className={cn(
        'flex h-[var(--heading-bar-height)] shrink-0 items-center justify-between',
        className,
      )}
      {...restProps}
    >
      <h1 className="text-base font-medium">Popular Products</h1>
      <div className="flex items-center gap-2">
        <Button
          variant={productViewMode === 'vertical' ? 'outline' : 'secondary'}
          className="size-10 p-0"
          onClick={() => handleToggle('vertical')}
        >
          <LayoutGrid strokeWidth={1.5} className="size-5" />
        </Button>
        <Button
          variant={productViewMode === 'horizontal' ? 'outline' : 'secondary'}
          className="size-10 p-0"
          onClick={() => handleToggle('horizontal')}
        >
          <List strokeWidth={1.5} className="size-5" />
        </Button>
      </div>
    </div>
  )
}
